interface UserAvatarIconProps {
  size?: number;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
}

export default function UserAvatarIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: UserAvatarIconProps) {
  return (
    <span className={className} onClick={onClick}>
      <svg width={size} height={size} viewBox='0 0 120 120' fill='currentColor'>
        <path d='M59.7557 119.454C43.1463 119.454 27.1983 112.454 15.9797 100.287C14.4797 98.6777 13.1463 97.0631 11.813 95.3444C-17.5777 57.0057 11.4224 -0.660938 59.7557 0.00572887C108.032 -0.660938 137.089 57.0057 107.698 95.2817C106.365 97.0057 105.032 98.6724 103.532 100.282C92.3077 112.448 76.365 119.448 59.7557 119.448V119.454ZM59.7557 8.33906C18.1983 7.78698 -6.80166 57.3391 18.4797 90.2871C19.589 91.7871 20.813 93.2297 22.089 94.6204C41.2557 116.396 78.2557 116.396 97.4223 94.6204C98.6984 93.2297 99.9223 91.7871 101.089 90.2297C126.313 57.2871 101.313 7.72973 59.813 8.28706L59.7557 8.33906Z' />
        <path d='M104.313 95.787C87.9223 57.287 31.5889 57.287 15.2036 95.787C14.5369 97.287 14.813 99.063 15.9796 100.287C38.2556 125.62 81.2556 125.62 103.537 100.287C104.646 99.0631 104.928 97.287 104.313 95.787Z' />
        <path d='M59.7556 16.6724C40.8649 16.1151 29.1463 39.5631 40.8129 54.3391C49.6463 66.9484 69.9223 66.9484 78.7036 54.3391C90.3703 39.5631 78.7036 16.1151 59.7609 16.6724H59.7556Z' />
      </svg>
    </span>
  );
}
